<template>
  <article
    class="md:col-span-6 md:col-start-1 md:row-start-1"
    :class="{ 'border-b-2 border-r-2 border-solid border-app-green': showBorder, 'bg-app-green-100 md:bg-white': mobileBgWhite }"
  >
    <h3 class="text-black mb-2 text-base font-bold leading-none uppercase">{{ title }}</h3>
    <p v-if="text" class="text-black mb-5">{{ text }}</p>
    <ul v-if="shareProfile.length" class="flex justify-center md:justify-start">
      <li v-for="(platform, index) in shareProfile" :key="index" class="px-2 md:pl-0 md:pr-3">
        <AtomLink
          :url="platform.url"
          class="group flex items-center justify-center w-10 h-10 bg-app-green rounded-full transition duration-200"
          :class="{ 'bg-app-green-100 md:bg-app-lime': mobileBgWhite, 'bg-white hover:bg-app-green': !mobileBgWhite }"
        >
          <LazyAtomIconAppFacebookF
            v-if="platform.icon === 'AppFacebookF'"
            class="shrink-0 w-6 h-6 transition duration-200"
            :class="{ 'text-app-green group-hover:text-white': !mobileBgWhite, 'text-black': mobileBgWhite }"
          />
          <LazyAtomIconAppXFormerlyKnownAsTwitter
            v-if="platform.icon === 'AppXFormerlyKnownAsTwitter'"
            class="shrink-0 w-6 h-6 transition duration-200"
            :class="{ 'text-app-green group-hover:text-white': !mobileBgWhite, 'text-black': mobileBgWhite }"
          />
          <LazyAtomIconMail
            v-if="platform.icon === 'Mail'"
            class="shrink-0 w-6 h-6 transition duration-200"
            :class="{ 'text-app-green group-hover:text-white': !mobileBgWhite, 'text-black': mobileBgWhite }"
          />
          <LazyAtomIconWhatsApp
            v-if="platform.icon === 'WhatsApp'"
            class="shrink-0 w-6 h-6 transition duration-200"
            :class="{ 'text-app-green group-hover:text-white': !mobileBgWhite, 'text-black': mobileBgWhite }"
          />

          <span class="sr-only">Icon {{ platform.name }}</span>
        </AtomLink>
      </li>
    </ul>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { setupTranslationPrefixer } from '~/composables/util'

interface Props {
  title: string
  text?: string
  mobileBgWhite?: boolean
  url: string
  showBorder?: boolean
}

const props = defineProps<Props>()

const { t_ } = setupTranslationPrefixer('Share')

const shareProfile = computed(() => [
  {
    icon: 'AppFacebookF',
    name: 'Facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${props.url}&quote=${t_('facebook-quote', { url: props.url })}`,
  },
  {
    icon: 'AppXFormerlyKnownAsTwitter',
    name: 'X',
    url: `https://twitter.com/intent/tweet?text=${encodeURI(t_('twitter-text', { url: props.url }))}`,
  },
  {
    icon: 'Mail',
    name: 'Mail',
    url: `mailto:?subject=${encodeURI(t_('mail-subject', { url: props.url }))}&body=${encodeURI(t_('mail-body', { url: props.url }))}`,
  },
  {
    icon: 'WhatsApp',
    name: 'WhatsApp',
    url: `https://wa.me/?text=${encodeURI(t_('whats-app-text', { url: props.url }))}`,
  },
])
</script>
